import { filter } from "lodash";
import { useSelector } from "react-redux";
import { Price } from "../common/Price";
import { Box, Flex } from "rebass";
import { NumericPad } from "../product/NumericPad";
import { AutocompleteButton } from "../common/AutocompleteButton";
import Tooltip from "../common/Tooltip";
import { getLocalizedString } from "../../utils";
import sizeSort from "../../utils/sizeSort";
import { useMemo } from "react";

const AvailabilityGridDoor = ({
  productId,
  doorId,
  color,
  catalog = null,
  orderType,
}) => {
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { me } = useSelector((state) => state.yodaStakeholders);
  const { orderRowDetails } = useSelector((state) => state.yodaOrders);

  const click = (id, color, door, idx) => {
    const numericPad = document.getElementById(
      [id, color, door, idx].join("_"),
    );
    numericPad.click();
  };

  const catalogId =
    catalog?.filter((item) => item.colorCode == color.code)?.[0]?.catalogId ||
    color?.catalogId;

  const rows = filter(
    orderRowDetails,
    (row, v) =>
      row.catalogId == catalogId &&
      doorId == row.customData?.doorId &&
      row.customData?.typeId == orderType,
  );

  const { quantity, price } = useMemo(() => {
    let quantity = 0;
    let price = 0;

    rows.forEach((row) => {
      quantity += row.currentQuantity;
      price += row.price;
    });

    return { quantity, price };
  }, [rows]);

  const doorData = customer?.doors?.find?.((door) => door.id == doorId);

  return (
    <>
      <Box
        height={"100%"}
        textAlign={"center"}
        style={{
          borderRight: "1px solid #E0E0E0",
          background: "#fff",
          position: "sticky",
          left: "100px",
          zIndex: 1,
        }}
      >
        <Flex
          style={{ minHeight: "35px" }}
          height={"100%"}
          w={1}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Tooltip content={doorData?.name || ""}>
            <Box
              style={{
                position: "relative",
                width: "calc(100% - 30px)",
                color: "#666666",
                fontSize: "12px",
                cursor: "help",
              }}
            >
              {getLocalizedString("Porta").toUpperCase()}{" "}
              <strong>{doorData?.code || ""}</strong>
            </Box>
          </Tooltip>
          {me?.role.includes?.("CustomerCare") && (
            <Box
              height={"100%"}
              style={{
                position: "relative",
                width: "30px",
                borderLeft: "1px solid #E0E0E0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                style={{ transform: "scale(0.6)" }}
                sx={{
                  "& > svg > g > g > g": {
                    fill: "#C1C1C1",
                    stroke: "#C1C1C1",
                  },
                  "& > svg > g > g > path": {
                    stroke: "#C1C1C1",
                  },
                }}
              >
                <AutocompleteButton
                  id={productId}
                  door={doorId}
                  color={color.code}
                  element={color}
                  config={orderType}
                ></AutocompleteButton>
              </Box>
            </Box>
          )}
        </Flex>
      </Box>

      {color.values.sort(sizeSort).map((e1, idx) => (
        <Box
          key={idx}
          sx={{
            "&:hover": {
              backgroundColor:
                color.values.filter((f) => f.sizeCode == e1.sizeCode)[0]
                  .quantity > 0
                  ? "#565656"
                  : "#464646",
            },
          }}
          style={{
            textAlign: "center",
            border: "1px solid #585858",
            borderTop: 0,
            borderLeft: 0,
            fontSize: "12px",
            borderRight:
              color.values?.length - 1 == idx
                ? "1px solid #F2F2F2"
                : "1px solid #585858",
          }}
          bg={"#464646"}
          color={"white"}
          onClick={() => click(productId, color.code, doorId, idx)}
        >
          <Box
            w={1}
            height={"100%"}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NumericPad
              index={idx}
              id={productId}
              type={orderType}
              sizeCode={e1.sizeCode}
              door={doorId}
              color={color.code}
              quantity={
                color.values.filter((f) => f.sizeCode == e1.sizeCode)[0]
                  .quantity
              }
            ></NumericPad>
          </Box>
        </Box>
      ))}

      <Box
        style={{
          borderBottom: "1px solid #F2F2F2",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        bg={"#646464"}
        color={"white"}
      >
        {quantity || 0}
      </Box>
      <Box
        style={{
          border: "1px solid #F2F2F2",
          borderTop: 0,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        bg={"#646464"}
        color={"white"}
      >
        <Price price={price}></Price>
      </Box>
    </>
  );
};

export default AvailabilityGridDoor;
